module.exports = __webpack_public_path__ + "img/41-2.5aee6d18.png";